import React, { Fragment } from "react";
import { shiftOfObject } from "@gqlapp/utils/filterObject";
import QRPointType from "../qrcode/QRPointType";

export function getStyle($options: any[], style:string){
	return shiftOfObject($options, function ($value: any, $key: string){
		return !!$value && [`${style}`, 'default'].includes($key);
	});
}

function mapData(name: string, obj: any, styleData: any){

	let type = obj?.type || 0;
	if(isNumber(type)){
		type = `${name}${type}`;
	}

	let { callback, options, ...rest }: any = getStyle(styleData, type);
	let data = func(callback)();

	return Object.assign({}, obj, options, { data })
}


/**
 * Map
 * @param $name
 * @param $datakeys
 * @param $data
 * @private
 */
export function map($name: string, $datakeys: any = {}, $data: any){
	let { top_left , top_right, bottom_left, other }: any = $datakeys || {};

	try{
		return {
			top_left:     mapData($name, top_left, $data),
			top_right:    mapData($name, top_right, $data),
			bottom_left:  mapData($name, bottom_left, $data),
			bottom_right: mapData($name, bottom_left, $data),
			other:        mapData($name, other, $data),
		}
	}catch (e){}
}


/**
 * @param $options
 */
export const renders = ($options: any = {}) => {
	let { custom, gb, width, type, dataType, x, y } = $options || {};
	let { transform, eyeInner, eyeShape, eyeBg } = $options || {};

	width = width || 1;


	let opts = { gb, custom, transform }
	const $ei = func(eyeInner?.render)({ ...opts, source: eyeInner });
	const $ef = func(eyeShape?.render)({ ...opts, source: eyeShape });
	const $ebg= func(eyeBg?.render)({ ...opts, source: eyeBg, type: dataType == 'other' ? QRPointType.$ALIGN_OTHER: null });


	let tX = x * width;
	let tY = y * width;
	let scale =  0.07 * width;

	let sizeEye = 120;

	let svg = <>
		<Fragment key={3}>{$ebg}</Fragment>
		<Fragment key={1}>{$ei}</Fragment>
		<Fragment key={2}>{$ef}</Fragment>
	</>

	/** Căn chỉnh mắt phụ **/
	if(dataType === 'other'){
		let smallSize = 5/7
		let exend = sizeEye * smallSize/2 - 12;
		tX += exend; tY += exend; scale *= smallSize;
	}

	return <g {...{ transform: `translate(${tX},${tY}) scale(${scale})` }}>{svg}</g>
}
